import { render } from "./AccountsTitleCard.vue?vue&type=template&id=f0d533d2"
import script from "./AccountsTitleCard.vue?vue&type=script&lang=js"
export * from "./AccountsTitleCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__